import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5523892d"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5523892d')) {
      api.createRecord('5523892d', component.options)
    } else {
      api.reload('5523892d', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5523892d", function () {
      api.rerender('5523892d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer/main.vue"
export default component.exports